// Modules
import { memo } from 'react';
import cn from 'classnames';

// Types
import type { FunctionComponent } from 'react';
import type { TSpinnerProps } from './Spinner.type';

// Styles
import styles from './styles.module.scss';

// Constants
import { SPINNER_DEFAULT_PROPS } from './Spinner.constant';

const Spinner = (props: TSpinnerProps) => {
	const {
		className,
		indicatorClassName,
		size = SPINNER_DEFAULT_PROPS.size,
		trackClassName,
		...restProps
	} = props;

	const spinnerCN = cn(styles.legion_spinner, className, styles[size!]);
	const indicatorCN = cn(styles.indicator, indicatorClassName);
	const trackCN = cn(styles.track, trackClassName);

	return (
		<div className={spinnerCN} {...restProps}>
			<svg
				className={indicatorCN}
				viewBox={'0 0 100 100'}
				preserveAspectRatio={'xMinyMin meet'}
				xmlns={'http://www.w3.org/2000/svg'}
			>
				<circle/>
			</svg>
			<svg
				className={trackCN}
				viewBox={'0 0 100 100'}
				preserveAspectRatio={'xMinyMin meet'}
				xmlns={'http://www.w3.org/2000/svg'}
			>
				<circle/>
			</svg>
		</div>
	);
}

const SpinnerMemo = memo(Spinner as FunctionComponent<TSpinnerProps>);
SpinnerMemo.displayName = 'Spinner';

export default SpinnerMemo;
